module.exports = __webpack_public_path__ + "assets/5-sales-development-rep-jobs.e8a914f2.png";